import { Component, OnInit } from "@angular/core";
import { NbDialogRef } from "@nebular/theme";
import {
  PauseIntegrationsService,
  SimpleIntegration,
} from "@services/pause-integrations.service";
import { tap } from "rxjs/operators";

@Component({
  selector: "app-course-archive-pause-integration-list",
  templateUrl: "./course-archive-pause-integration-list.component.html",
  styleUrls: ["./course-archive-pause-integration-list.component.scss"],
})
export class CourseArchivePauseIntegrationListComponent implements OnInit {
  public integrations$;
  public integrations: SimpleIntegration[] = [];
  public hasError = false;
  public isLoading = true;
  constructor(
    private pauseIntegrationService: PauseIntegrationsService,
    private dialogRef: NbDialogRef<CourseArchivePauseIntegrationListComponent>
  ) {}

  ngOnInit() {
    this.integrations$ = this.pauseIntegrationService.getIntegrations$().pipe(
      tap(({ integrations, isLoading, hasError }) => {
        this.isLoading = isLoading;
        this.integrations = integrations;
        this.hasError = hasError;
      })
    );
  }

  close() {
    this.dialogRef.close();
  }

  updateIntegrationPauseState(integration: SimpleIntegration) {
    this.pauseIntegrationService.updateIntegrationPauseState(
      integration,
      !integration.paused
    );
  }
}
